/* case-template:
 *
 * Use a template to render a case element
 *
 * Author: Niels Giesen
 * Copyright 2014 Berkeley Bridge
 *
 */

import Mustache from "mustache";
import { bb } from "$json";

(function ($, win, doc) {
  var tmpl;

  bb.createCaseItem = function (cas) {
    return Mustache.render(tmpl, cas);
  };

  $(function () {
    tmpl = $("#bb-p-case-template").html();
    Mustache.tags = ["[[", "]]"];
  });

  $(doc).on("click", ".copy-case-access-url", e => {
    try {
      let $button = $(e.target).parents("td").find(".copy-case-access-url"),
        $input = $(e.target).parents("td").find(".case-access-url"),
        uniquid = bb.getVar("userinfo").uniqueid,
        params = $input.attr("data-params"),
        url = `${window.location.href}${params}&uniqueid=${uniquid}`;

      $input.val(url).removeClass("a-offscreen");

      $button.addClass("a-offscreen");

      $input.get(0).select();
      $input.get(0).setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      if (document.execCommand("copy")) {
        let $message = $(`
          <div>
            Temporary link copied to clipboard...<br />
            <strong>Warning:</strong><br />
            This link will give access to the
            server via your current credentials.
          </div>
        `);
        $(e.target).parents("td").prepend($message);
        win.setTimeout(() => $message.fadeOut(1000), 1e4);
      }
    } catch (err) {
      console.warn(err);
      $(e.target).parents("td").find(".case-access-url").remove();

      $(e.target)
        .parents("td")
        .find(".copy-case-access-url")
        .replaceWith("<span>Unable to get case link</span>");
    }
  });
})(jQuery, window, document);
